export const GET_LADDER_VIDEO_LIST = 'GET_LADDER_VIDEO_LIST'; // 天梯四排赛-获取回放视频列表

export const UPDATE_LADDER_VIDEO = 'UPDATE_LADDER_VIDEO'; // 天梯四排赛-修改回放视频

export const DELETE_LADDER_VIDEO = 'DELETE_LADDER_VIDEO'; // 天梯四排赛-删除回放视频
